<template>
    <u-main-section-basic v-bind="$attrs" titWrapClass="tit-wrap--lg">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-main-section-basic>
</template>

<script>
import UMainSectionBasic from "@/sets/styles/mains/u-main-section-basic.vue";

export default {
    props: {},
    components: {
        UMainSectionBasic,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>
